import { EmptyState } from "@coaching-culture/ui";
import { FaInfoCircle } from "react-icons/fa";

export const NoDataWidget = ({ text }: { text: string }) => (
  <EmptyState compact icon={FaInfoCircle}>
    {text}
  </EmptyState>
);
